import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';


const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ModalExcludeInclude = ({ feasibility, closeIncludeExcludeModal, opened, visits,listIncludesExclude }) => {
    const [openModal, setOpenModal] = React.useState(opened);

    //Atributos
    const [orden, setOrden] = React.useState(null);
    const [genero, setGenero] = React.useState(1);
    const [tipo, setTipo] = React.useState(1);
    const [descripcion, setDescripcion] = React.useState(null);

    //Alerta
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const checkedDays = [];

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    React.useEffect(() => {

    }, []);

    const handleChangeCheckbox = (value, check) => {

        if (check == true) {
            checkedDays.push(parseInt(value));
        }
        else {
            let position = checkedDays.indexOf(parseInt(value));
            if (position > -1) {
                checkedDays.splice(position, 1);
            }
        }
    }


    const addIncludeExclude = () => 
    {
        //Validacion
        if (orden == null) {
            alertModal(false, "El Orden es Requerido");
            return;
        }
        if (genero == null) {
            alertModal(false, "El Genero es requerido");
            return;
        }
        if (tipo == null) {
            alertModal(false, "El tipo es Requerido");
            return;
        }
        if (descripcion == null) {
            alertModal(false, "Descripcion");
            return;
        }

        let dataExcInc = new FormData();
        dataExcInc.append('id_estudio',feasibility.id_estudio);
        dataExcInc.append('tipo',tipo);
        dataExcInc.append('orden',orden);
        dataExcInc.append('descripcion',descripcion);
        dataExcInc.append('genero',genero);
        dataExcInc.append('visitas',checkedDays);

        fetch(`${process.env.REACT_APP_PUBLIC_URL}criteriose/create`, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataExcInc
        }).then(response => response.json()).then(data => {
            listIncludesExclude(feasibility.id_estudio);
            closeIncludeExcludeModal();
        }).catch(err => {

        });
    }
    

    const CheckboxVisits = () => {
        let _row = [];
        try {
            visits.map((item, i) => {
                _row.push(
                    <FormControlLabel
                        value={item.id_visita}
                        control={
                            <MedicalCheckbox
                                onChange={(event, check) => {
                                    handleChangeCheckbox(event.target.value, check)
                                }}
                                iconStyle={{ fill: 'green' }}
                            />
                        }
                        label={item.num_visita.toString()}
                        labelPlacement={item.num_visita.toString()}
                    />
                )
            });
        }
        catch (e) {

        }

        return (
            <FormGroup style={{ overflow: 'scroll', maxHeight: '100px' }} aria-label="position" row>
                {_row}
            </FormGroup>

        );
    }

    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    setOpenModal(false);
                    closeIncludeExcludeModal(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Agregar Inclusion/Exclusion</h5>
                        </div>

                        <Row>
                            <Col md={4}>
                                <TextField
                                    label=" "
                                    helperText="Orden"
                                    value={orden}
                                    type="number"
                                    onChange={(event) => {
                                        setOrden(event.target.value);
                                    }}

                                    style={{ minWidth: '200px', maxWidth: '100%' }}

                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                </TextField>
                            </Col>
                            <Col md={4}>
                                <TextField
                                    select
                                    label=" "
                                    helperText="Tipo"
                                    value={tipo}

                                    onChange={(event) => {
                                        setTipo(event.target.value);
                                    }}

                                    style={{ minWidth: '200px', maxWidth: '100%' }}

                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    <MenuItem key={1} value={1}>
                                        Inclusión
                                    </MenuItem>
                                    <MenuItem key={2} value={2}>
                                        Exclusión
                                    </MenuItem>
                                </TextField>
                            </Col>
                            <Col md={4}>
                                <TextField
                                    select
                                    label=" "
                                    helperText="Genero"
                                    value={genero}

                                    onChange={(event) => {
                                        setGenero(event.target.value);
                                    }}

                                    style={{ minWidth: '200px', maxWidth: '100%' }}

                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    <MenuItem key={1} value={1}>
                                        Ambos
                                    </MenuItem>
                                    <MenuItem key={2} value={2}>
                                        Masculino
                                    </MenuItem>
                                    <MenuItem key={3} value={3}>
                                        Femenino
                                    </MenuItem>
                                </TextField>
                            </Col>
                            <Col md={12}>
                                <TextField
                                    multiline
                                    label=" "
                                    helperText="Descripcion"
                                    value={descripcion}
                                    rows={3}
                                    onChange={(event) => {
                                        setDescripcion(event.target.value);
                                    }}

                                    style={{ 
                                        minWidth: '200px',
                                        maxWidth: '100%' 
                                    }}

                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                        </Row>

                        <Container>
                            <CheckboxVisits />
                        </Container>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                addIncludeExclude();
                            }}
                        >
                            Crear
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                setOpenModal(false);
                                closeIncludeExcludeModal(false);
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => setAlerShowModal(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalExcludeInclude;
